import { useNavigate } from "react-router-dom";
import { MY_DETAILS_FULL_PATH } from "config/common";
import { IAddress } from "services/api/BillingApi/BillingApi";
import checkIsValidAddress from "helpers/checkIsValidAddress";
import { useReturnUrl } from "app/hooks/useReturnUrl";
import { useUpdateDetailsPopUp } from "app/hooks/useUpdateDetailsPopUp";

export function useValidAddressOrRedirectAction({
  address,
  redirect,
  returnPath,
}: {
  address: IAddress | undefined;
  redirect: string;
  returnPath: string;
}): () => void {
  const navigate = useNavigate();
  const { redirectWithReturnUrl } = useReturnUrl();

  const isValidAddress = checkIsValidAddress(address);

  const handleRedirectUser = () => {
    if (!isValidAddress) {
      return redirectWithReturnUrl(MY_DETAILS_FULL_PATH, returnPath);
    }

    navigate(redirect);
  };

  const { showUpdateDetailsPopUp } = useUpdateDetailsPopUp(handleRedirectUser);

  return () => {
    if (isValidAddress) return handleRedirectUser();

    return showUpdateDetailsPopUp();
  };
}
